
const digest = 'c44e73c1cb5fa49f94d8a1d02db67afffc77b1500598e183f618ef04c63e45f0';
const classes = {"wrapper":"_wrapper_3s5jc_1","toggleButton":"_toggleButton_3s5jc_4"};
const css = `._wrapper_3s5jc_1 {
  position: relative;
}
._wrapper_3s5jc_1 ._toggleButton_3s5jc_4 {
  cursor: pointer;
  border-radius: 100%;
  background-color: #1452ac;
  font-size: 16px;
  position: relative;
  color: #fff;
  width: 42px;
  height: 42px;
  display: block;
  text-align: center;
  line-height: 44px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  